import type { ProductSecuredLoanConfig } from '../../@types/context/product-secured-loan-config.types';

export const securedLoanCaseConfig: Pick<ProductSecuredLoanConfig, 'case'> = {
  case: {
    categories: ['payslip', 'tax-return', 'other'],
    maxFileSize: 1024 * 1024 * 20, // 1024 * 1024 * 20 (20MB)
    maxFiles: 1,
    allowedFileTypes: ['application/pdf', 'image/jpeg', 'image/png'],
  },
};
